<template>
    <div class="container">
        <div class="navigation-wrapper">
            <div class="row">
                <div class="col-12">
                    <router-link to="/">
                        <img class="img img-logo" src="/_resources/themes/bellstores/javascript/loyalty-program/src/assets/images/logo-bell-buddy-rewards.png" alt="Bell Buddy Rewards Logo" />
                    </router-link>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <h1>New Member Registration</h1>

                <div v-for="error in errorMessages" v-bind:key="error">
                    <div class="alert alert-danger">
                        {{error}}
                    </div>
                </div>

                <form v-on:submit="onSubmit" class="register-form" :class="{ 'was-validated': formValidated }">
                    <p class="small">* Indicates a required field</p>

                    <div class="section">
                        <div class="row">
                            <div class="col-12">
                                <h3 class="text-left">Personal Info</h3>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-xs-12 col-sm-6">
                                <div class="form-group">
                                    <input type="text" class="form-control" name="firstName" placeholder="*First Name" v-model="registration.required.firstName" required />
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-6">
                                <div class="form-group">
                                    <input type="text" class="form-control" name="lastName" placeholder="*Last Name" v-model="registration.required.lastName" required />
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-xs-12 col-sm-6">
                                <div class="form-group">
                                    <input type="email" class="form-control" name="userId" placeholder="*Email Address" v-model="registration.required.userId" required />
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-6">
                                <div class="form-group">
                                    <input type="tel" class="form-control" name="mobilePhone" placeholder="*Phone" v-model="registration.required.primaryPhone" pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}|[0-9]{10}" required />
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-xs-12 col-sm-6">
                                <div class="form-group">
                                    <input type="text" class="form-control" name="zipCode" placeholder="*Zip Code"
                                           v-model="registration.required.zipCode" required/>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-6">
                                <div class="row birthDateRow">
                                    <div class="col">
                                        <div class="form-group">
                                            <select v-model="birthMonth" name="birthMonth" class="form-control" required>
                                                <option value="">*Birth Month</option>
                                                <option value="01">January</option>
                                                <option value="02">February</option>
                                                <option value="03">March</option>
                                                <option value="04">April</option>
                                                <option value="05">May</option>
                                                <option value="06">June</option>
                                                <option value="07">July</option>
                                                <option value="08">August</option>
                                                <option value="09">September</option>
                                                <option value="10">October</option>
                                                <option value="11">November</option>
                                                <option value="12">December</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div class="form-group">
                                            <select v-model="birthDay" name="birthDay" class="form-control" required>
                                                <option value="">*Birth Day</option>
                                                <option v-for="(day, index) in getBirthDays" :key="index" :value="day">{{ day }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div class="form-group">
                                            <select v-model="birthYear" name="birthYear" class="form-control" required>
                                                <option value="">*Birth Year</option>
                                                <option v-for="(year, index) in getBirthYears" :key="index" :value="year">{{ year }}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="section">
                        <div class="row">
                            <div class="col-12">
                                <h3 class="text-left">Password</h3>
                            </div>
                            <div class="col-12 text-left">
                                <p><small>Password must be at least 8 characters long, include both uppercase and lowercase letters, one number, and one special character. Do not reuse previous passwords and exclude any part of your name.</small></p>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-xs-12 col-sm-6">
                                <div class="form-group">
                                    <input type="password" class="form-control" :class="{ 'is-valid': passwordsMatch, 'is-invalid': passwordsDontMatch }" name="password" placeholder="*Password" v-model="registration.required.password" required />
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-6">
                                <div class="form-group">
                                    <input type="password" class="form-control" :class="{ 'is-valid': passwordsMatch, 'is-invalid': passwordsDontMatch }" name="password" placeholder="*Confirm Password" v-model="registration.required.confirmPassword" required>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <h3 class="text-left">Connect a Bell Buddy Rewards<sup>SM</sup> Card (optional)</h3>
                        </div>
                        <div class="col-12 text-left">
                            <p><small>Not required. A Bell Buddy Rewards<sup>SM</sup> Card can be added at any time.</small></p>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <div class="form-group">
                                <input type="text" class="form-control" name="zipCode" placeholder="Bell Buddy Rewards Card Number" v-model="registration.optional.cardNumber" />
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-xs-12 col-md-6">
                            <div class="form-group">
                                <span class="check-row">
                                    <input type="checkbox" id="terms" name="tcAction" class="form-check-input" value="true" v-model="registration.required.tcAction">
                                    <label for="terms">*I agree to all terms and conditions</label>
                                </span>
                            </div>
                        </div>
                        <div class="col-xs-12 col-md-6">
                            <div class="form-group">
                                <span class="check-row">
                                    <input type="checkbox" name="marcomOptIn" id="marComOpt" class="form-check-input" value="true" v-model="registration.optional.marcomOptIn">
                                    <label for="marComOpt">Please send me offers and special promotions.</label>
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <button type="submit" class="btn btn-primary btn-bellstores" :disabled="!isValid">Submit</button>
                            <router-link to="/login" class="btn-primary btn btn-bellstores" replace>
                                Cancel
                            </router-link>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import APIResponseError from '@/models/responses/APIResponseError'
import APIRequestError from '@/models/responses/APIRequestError'

export default {
    name: 'Register',
    dependencies: ['apiService', 'storageService'],
    components: {

    },
    data () {
        return {
            registration: {
                optional: {
                    primaryPhoneType: '',
                    secondaryPhone: '',
                    secondaryPhoneType: '',
                    marcomOptIn: '',
                    cardNumber: ''
                },
                required: {
                    userId: '',
                    password: '',
                    confirmPassword: '',
                    firstName: '',
                    lastName: '',
                    zipCode: '',
                    birthDate: '',
                    primaryPhone: '',
                    tcAction: false, // must be true
                    partnerSourceId: 'bellstoreweb'
                }
            },
            birthMonth: '',
            birthDay: '',
            birthYear: '',
            errorMessages: []
        }
    },
    methods: {
        formatDate (date) {
            if (!date) {
                return ''
            }

            return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`
        },
        async onSubmit (e) {
            e.preventDefault()
            this.errorMessages = []

            this.registration.required.birthDate = new Date(this.birthYear, this.birthMonth - 1, this.birthDay)

            const required = this.registration.required
            const optional = this.registration.optional

            const memberAttributes = {}
            // eslint-disable-next-line no-unused-vars
            for (const k in required) {
                memberAttributes[k] = required[k]
            }

            // eslint-disable-next-line no-unused-vars
            for (const k in optional) {
                memberAttributes[k] = optional[k]
            }

            if (!this.apiService.isAuthenticated()) {
                await this.apiService.auth()
            }

            memberAttributes.birthDate = this.formatDate(memberAttributes.birthDate)

            console.log(memberAttributes)
            const response = await this.apiService.registerMember(memberAttributes)

            if (response instanceof APIResponseError || response instanceof APIRequestError) {
                this.errorMessages.push(response.message())
                return
            }

            this.storageService.setByKey('member', response.toStore())
            this.storageService.setByKey('logged_in', true)

            if (optional.cardNumber !== '') {
                const linkCardResponse = await this.apiService.linkCard(optional.cardNumber)

                if (linkCardResponse instanceof APIResponseError || linkCardResponse instanceof APIRequestError) {
                    this.$router.replace({ name: 'ManageCards' })
                }
            }

            this.$router.replace({ name: 'Home' })
        }
    },
    computed: {
        isValid () {
            return this.registration.required.userId !== '' &&
                this.registration.required.password !== '' &&
                this.registration.required.confirmPassword !== '' &&
                this.registration.required.zipCode !== '' &&
                this.registration.required.tcAction &&
                this.birthMonth !== '' &&
                this.birthDay !== '' &&
                this.birthYear !== '' &&
                this.registration.required.firstName !== '' &&
                this.registration.required.lastName !== '' &&
                this.registration.required.primaryPhone !== '' &&
                (this.registration.required.password === this.registration.required.confirmPassword)
        },
        getBirthDays () {
            const birthDays = []
            let i

            for (i = 1; i <= 31; i++) {
                birthDays.push(('0' + i).slice(-2))
            }

            return birthDays
        },
        getBirthYears () {
            const birthYears = []
            let i
            const d = new Date()
            const year = d.getFullYear()

            for (i = 0; i <= 120; i++) {
                birthYears.push(year - i)
            }

            return birthYears
        },
        formValidated () {
            return this.registration.required.tcAction
        },
        passwordsMatch () {
            return this.registration.required.password !== '' &&
                this.registration.required.confirmPassword !== '' &&
                (this.registration.required.password === this.registration.required.confirmPassword)
        },
        passwordsDontMatch () {
            return this.registration.required.password !== '' &&
                this.registration.required.confirmPassword !== '' &&
                (this.registration.required.password !== this.registration.required.confirmPassword)
        }
    }
}
</script>

<style scoped lang="scss">
    .check-row {
        margin-left: 25px;
        margin-right: 25px;
    }

    .register-form {
        margin-bottom: 40px;
    }

    .section {
        margin-bottom: 30px;
    }

    .birthDateRow {
        margin-left: -2.5px;
        margin-right: -2.5px;

        .col {
            padding-left: 2.5px;
            padding-right: 2.5px;
        }
    }

    .img-logo {
        width: 100% !important;
        margin-bottom: 50px !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/Register.vue